import React from 'react';
import { MenuContainer } from './styles';
import { navigationMenu } from '../../../../../constatnts/navigation';
import { Breadcrumb } from 'antd';

const Menu = () => {
  const menuLinks = navigationMenu.map((item) => ({
    title: item.title,
    href: item.href,
  }));
  return (
    <MenuContainer>
      <Breadcrumb separator='|' items={menuLinks} />
    </MenuContainer>
  );
};

export default Menu;
